import { Article, NewArticle, GetArticleOrStoryResponse } from '../types';
import axiosConnector from './axiosConnector';
import { toArticleDTO } from '../dto/articleDTO';
import { API_URL } from './axiosConnector';

export const getArticles = async (
  page: number = 1,
  sortBy: { id: string, desc: boolean } = { id: 'id', desc: true },
  filters: any = {}
): Promise<GetArticleOrStoryResponse> => {
  try {
    let url = `${API_URL}/articles?page=${page}&orderBy=${sortBy.id}&desc=${sortBy.desc ? 'desc' : 'asc'}`;

    if (filters) {
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== '') {
          url += `&${encodeURIComponent(key)}=${encodeURIComponent(
            filters[key]
          )}`;
        }
      });
    }

    const articlesResponse = await axiosConnector.get<GetArticleOrStoryResponse>(url);
    const articles = articlesResponse.data;

    const transformedArticles = articles.data.map(toArticleDTO);
    return {
      data: transformedArticles,
      pagination: articles.pagination,
    };
  } catch (error) {
    console.error(error);
    return {
      data: [],
      pagination: { total_records: 0, current_page: 1, total_pages: 1, next_page: null, prev_page: null },
    };
  }
};

export const updateArticle = async (
  article: Article
): Promise<Article | null> => {
  try {
    const articleResponse = await axiosConnector.patch<Article>(
      `${API_URL}/articles/${article.id}`,
      article
    );

    return toArticleDTO(articleResponse.data);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createArticle = async (
  article: NewArticle
): Promise<Article | null> => {
  try {
    const articleResponse = await axiosConnector.post<Article>(
      `${API_URL}/articles`,
      article
    );

    return toArticleDTO(articleResponse.data);
  } catch (error) {
    console.error(error);
    return null;
  }
};

interface DeleteArticleResponse {
  status: string;
}

export const deleteArticle = async (
  articleId: number
): Promise<DeleteArticleResponse | null> => {
  try {
    const articleResponse = await axiosConnector.remove<DeleteArticleResponse>(
      `${API_URL}/articles/${articleId}`
    );

    return { status: articleResponse.data.status };
  } catch (error) {
    console.error(error);
    return null;
  }
};
